export default __webpack_public_path__ + "static/media/Calendar.ca57c683.svg";